/**
 * Feature flag constants
 * Define all feature flags used throughout the application here.
 * This provides a centralized location for flag names and prevents typos.
 *
 * import { useFlag } from '@unleash/proxy-client-react';
 * const TestComponent = () => {
 *  const enabled = useFlag('travel.landing');
 * if (enabled) {
 *   return <SomeComponent />;
 * }
 * return <AnotherComponent />;
 * };
 */

import { useFlag, useUnleashContext } from '@unleash/proxy-client-react';

// https://docs.getunleash.io/sdks/react
// Placeholder: Add your feature flags here as you develop new features
const FEATURE_FLAGS = {
  DRAFT_CAMPAIGN: 'sc.feature.draft_campaign',
};

/**
 * Safe wrapper around useFlag that gracefully handles missing FlagProvider context.
 * Returns false if FlagProvider is not available (e.g., in e2e tests with Unleash disabled).
 */
export function useSafeFlag(flagName) {
  try {
    return useFlag(flagName);
  } catch {
    return false;
  }
}

/**
 * Safe wrapper around useUnleashContext that gracefully handles missing FlagProvider context.
 * Returns null if FlagProvider is not available (e.g., in e2e tests with Unleash disabled).
 */
export function useSafeUnleashContext() {
  try {
    return useUnleashContext();
  } catch {
    return null;
  }
}

export default FEATURE_FLAGS;
